import { getCookie } from './thdUserInfo';

const validatePage = () => {
  if (typeof window === 'undefined') return false;

  if ((window.digitalData.page)
    && (window.digitalData.page.pageInfo)
    && window.digitalData.page.pageInfo.pageName
    && window.digitalData.page.pageInfo.pageType) {
    return true;
  }
  return false;
};

const validateUser = () => {
  if (typeof window === 'undefined') return false;

  if ((window.digitalData.user)
    && (window.digitalData.user.profile)
    && window.digitalData.user.profile.authenticationStatus) {
    return true;
  }
  return false;
};

const ddoInit = (ddo) => {
  if (typeof window === 'undefined') return;

  const _T = window._T || undefined;
  window._T = window._T ? _T : {};
  _T.pageData = window._T.pageData ? _T.pageData : [];
  _T.pageData.push(ddo || window.digitalData);
};

const tryInitialize = () => {
  if (typeof window === 'undefined') return;
  if (validatePage() && validateUser()) {
    ddoInit(window.digitalData);
  }
};

export const setPage = (page) => {
  if (typeof window === 'undefined') return;

  window.digitalData.page = page;
  tryInitialize();
};

export const setPageInfo = (pageName, pageType) => {
  if (typeof window === 'undefined') return;

  const pageInfo = { pageName, pageType };

  if (!window.digitalData.page) {
    window.digitalData.page = {};
  }
  window.digitalData.page.pageInfo = pageInfo;
  tryInitialize();
};

export const setAdditionalPageInfo = (propertyName, additionalData) => {
  if (typeof window === 'undefined') return;

  if (!window.digitalData.page) {
    window.digitalData.page = {};
  }

  switch (propertyName) {
  case 'category':
    window.digitalData.page.category = { ...additionalData };
    break;
  case 'eventInfo':
    window.digitalData.page.inventInfo = { ...additionalData };
    break;
  case 'pageInfo':
    window.digitalData.page.pageInfo = { ...additionalData };
    break;
  default:
  }
};

export const setAuthenticationStatus = (authenticationStatus) => {
  if (typeof window === 'undefined') return;

  window.digitalData.user = window.digitalData.user || {};
  window.digitalData.user.profile = window.digitalData.user.profile || {};
  window.digitalData.user.profile.authenticationStatus = authenticationStatus;
  tryInitialize();
};

export const setSiteInfo = () => {
  if (typeof window === 'undefined') return;

  const site = getCookie('HD_DC');
  let siteVal = '';
  if (site === 'origin') { siteVal = 'prod'; }
  if (site === 'beta') { siteVal = 'beta'; }
  window.digitalData.site.siteID = 'GCC';
  window.digitalData.site.betaSite = siteVal;
};
